import React from 'react';

export default ({report}) => (
  <React.Fragment>
    <strong>{report.title || 'Not Provided'}</strong><br />
    Quarter: <strong>{report.quarter || 'Not Provided'}</strong><br />
    End Of Quarter: <strong>{report.endOfQuarter || 'Not Provided'}</strong><br />
    Date Range: <strong>{report.dateRange || 'Not Provided'}</strong>
  </React.Fragment>
);


// WEBPACK FOOTER //
// ./src/views/report/report-header-title.js